/** Web: copy to the clipboard. 'failed' when the browser refuses (the caller keeps the text selectable). */
export async function copyText(text: string): Promise<'copied' | 'shared' | 'failed'> {
  try {
    await navigator.clipboard.writeText(text);
    return 'copied';
  } catch {
    return 'failed';
  }
}
